import {
  AsearchComp
} from '@/service/app'
const searchEntity = {
  data() {
    return {
      entityList: [],
      entityKeyword: '',
    }
  },
  methods: {
    /**
     * 检索公司
     */
    async handleSearchEntity() {
      let res = await AsearchComp({
        boardId: 1,
        keyword: this.entityKeyword,
        page: 1,
        size: 10,
      })
      if (res.code == 0) this.entityList = [...res.data]
    },
    /**
     * 选择公司交互
     */
    handleSelectEntity(value) {
      let item = this.entityList.find((a) => a.id === value)
      this.$nextTick(() => {
        this.entityKeyword = ''
        this.currentForm.entityId = item.id
        this.currentForm.compName = item.shortName
      })
    },
    /**
     * 选择公司后 compName 字段发生改变
     */
    handleChangeEntity() {
      if (!this.currentForm.entityId) {
        this.currentForm.compName = this.entityKeyword
      }
    },
    handleClose() {
      this.currentForm.entityId = ''
      this.currentForm.compName = this.entityKeyword
    },
  },
}
export { searchEntity }
